import { useLookup } from "@ofqual/portal-core/core/hooks";
import { User } from "../domain/User";
import { buildUserAndTeamList } from "./userListHelper";
import { usersService } from "../services";

export const useGetTeamsAndUsers = () => {
  const [userLookups] = useLookup({
    service: usersService,
    id: "id",
    label: "label",
    params: {
      active: true
    },
  });
  const rawUsers = (userLookups as unknown) as User[];
  const { users, teams } = buildUserAndTeamList(rawUsers);

  return { userLookups: users, teamLookups: teams, users: rawUsers };
};
